var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full bg-neutral-25 rounded-xl border border-neutral-25 overflow-hidden pointer-events-none",staticStyle:{"height":"120px"}},[_c('div',{staticClass:"browser-preview-container"},[_c('div',{staticClass:"text-block px-1.5 py-1 bg-neutral-25 text-text-muted"},[_vm._v(" 300K+ People ")])])])
}]

export { render, staticRenderFns }